import { OfferPrice, OfferPriceType } from 'types/offer'

export const getStandardPrice = (offerPrices: OfferPrice[]): OfferPrice =>
  offerPrices.find((offerPrice) => offerPrice.type === OfferPriceType.standard)

export const getChancePrice = (offerPrices: OfferPrice[]): OfferPrice =>
  offerPrices.find((offerPrice) => offerPrice.type === OfferPriceType.chance)
